export default "__VITE_ASSET__DNMyUHP9__"